import { autocomplete, IAutoComplete } from 'src/app/features/shared/controls/models/auto-complete.model';

// Gedeelde notatie voor het creditsysteem. Locale bewust undefined: de browser/OS-instelling van de kijker
// bepaalt de notatie (zie AppDatePipe). Een "periode" is altijd de 1e van een maand als 'yyyy-MM-dd'.

export function period_label(period: string | null | undefined): string {
    if (!period) return '';
    const [__y, __m] = period.split('-').map(Number);
    return new Intl.DateTimeFormat(undefined, { month: 'long', year: 'numeric' }).format(new Date(__y, __m - 1, 1));
}

export function period_of(date: Date): string {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-01`;
}

// De 1e van de lopende maand plus offset (in maanden), lokaal; de backend rekent per kalendermaand.
export function period_offset(offset: number): string {
    const __now = new Date();
    return period_of(new Date(__now.getFullYear(), __now.getMonth() + offset, 1));
}

// Keuzelijst van maanden: van `from` tot en met `to` (offsets t.o.v. de lopende maand), nieuwste eerst.
export function period_list(from: number, to: number): IAutoComplete[] {
    const __list: IAutoComplete[] = [];
    for (let __i = to; __i >= from; __i--) {
        const __period = period_offset(__i);
        __list.push({ [autocomplete.itemId]: __period, [autocomplete.itemText]: period_label(__period) });
    }
    return __list;
}

export function money_format(value: number | null | undefined): string {
    if (value == null) return '';
    return value.toLocaleString(undefined, { style: 'currency', currency: 'EUR' });
}

export function number_format(value: number | null | undefined): string {
    if (value == null) return '';
    return value.toLocaleString(undefined);
}

// Leeg → null; anders de getrimde tekst.
export function text_normalize(value: string | number | null | undefined): string | null {
    const __text = value == null ? '' : String(value).trim();
    return __text === '' ? null : __text;
}

export const integerPattern = /^-?\d+$/;
export const positiveIntegerPattern = /^\d+$/;
export const decimalPattern = /^\d+([.,]\d{1,4})?$/;

export function decimal_parse(value: string | null): number {
    return Number(String(value ?? '').replace(',', '.'));
}

// Opslag in MB (1 MB = 1024²), zoals de blokgrootte in BillingSettings.
export function bytes_format(bytes: number | null | undefined): string {
    if (bytes == null) return '';
    return `${(bytes / (1024 * 1024)).toLocaleString(undefined, { maximumFractionDigits: 1 })} MB`;
}
